import { useCallback, useEffect } from 'react';

import {
  PerformanceTrackingAbortReasons,
  TOTAL_REMOTE_LOADING_TIME,
  abortTracking,
} from '@adsk/exo-skeleton-api';

import { REMOTE_TRACKING_TIMEOUT } from '../helpers/consts';
import { useRemote } from '../providers/RemoteProvider';

export const useRemoteTrackingHandler = ({
  moduleName,
  scope,
}: {
  scope: string;
  moduleName: string;
}) => {
  const { trackLoading } = useRemote();

  const abortTrackingHandler = useCallback(
    ({ reason }: { reason: PerformanceTrackingAbortReasons }) =>
      abortTracking({
        scope,
        moduleName,
        trackingId: TOTAL_REMOTE_LOADING_TIME,
        reason,
      }),
    [scope, moduleName],
  );

  useEffect(() => {
    trackLoading();

    const timeout = setTimeout(() => {
      void abortTrackingHandler({ reason: 'timeout' });
    }, REMOTE_TRACKING_TIMEOUT);

    return () => {
      void abortTrackingHandler({ reason: 'unmount' });
      clearTimeout(timeout);
    };

    // for every scope or moduleName changes, we need to abort the previous tracking and start a new one
  }, [scope, moduleName, abortTrackingHandler, trackLoading]);
};
